import { Separator } from "@loot-os/ui/components/separator";

import type { PageLayoutProps } from "../../contract.js";
import type { BoxesContent } from "../../pages/boxes/contract.js";

/**
 * The classic boxes page: the breadcrumb, the title beside its tabs, the filters over a rule, then
 * the top hits and the grid. Stacked on a phone, the tabs under the title and the rule dropped.
 */
export function ClassicBoxesLayout({ sections }: PageLayoutProps<BoxesContent>) {
  return (
    <div className="flex flex-col gap-5 md:gap-6">
      <div className="flex flex-col gap-4 md:gap-5">
        {sections.breadcrumb}
        <div className="flex flex-col gap-4 md:flex-row md:items-center">
          {sections.title}
          {sections.tabs}
        </div>
        {sections.filters}
        <Separator className="hidden md:block" />
      </div>
      {sections.topHits}
      {sections.grid}
    </div>
  );
}
